import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useMediaUrl } from './useMediaSasToken';

interface OnboardingImageProps {
  /** Path relative to the media container, e.g. "images/Journey%201/Phase%201%20-%20Step%203/Frame.png" */
  imagePath: string;
  alt?: string;
  height?: number;
}

export const OnboardingImage = ({
  imagePath,
  alt = '',
  height = 280,
}: OnboardingImageProps) => {
  const theme = useTheme();
  const isDarkTheme = theme.palette.type === 'dark';
  const { fetchMediaUrl, baseUrl } = useMediaUrl();
  const [imageUrl, setImageUrl] = useState<string>('');

  useEffect(() => {
    if (!baseUrl) return;
    let cancelled = false;
    fetchMediaUrl(imagePath).then(url => { if (!cancelled) setImageUrl(url); }).catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [baseUrl, imagePath, fetchMediaUrl]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  if (error) {
    return (
      <Box
        style={{
          height,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#1a1a1a',
          borderRadius: 8,
          marginBottom: 16,
        }}
      >
        <Typography variant="caption" style={{ color: '#999' }}>
          Image unavailable
        </Typography>
      </Box>
    );
  }

  return (
    <Box style={{ marginBottom: 16, position: 'relative', height }}>
      {(loading || !imageUrl) && (
        <Box
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#1a1a1a',
            borderRadius: 8,
          }}
        >
          <CircularProgress size={32} />
        </Box>
      )}
      {imageUrl && (
        <img
          src={imageUrl}
          alt={alt}
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
          style={{
            width: '100%',
            height,
            borderRadius: 8,
            objectFit: 'contain',
            backgroundColor: isDarkTheme ? '#424242' : '#fff',
            opacity: loading ? 0 : 1,
          }}
        />
      )}
    </Box>
  );
};
